import React from 'react'
import { connect } from 'react-redux'
import { Tab, Grid, Segment } from 'semantic-ui-react'
import { actions as LKModalActions } from 'shared/LKModal'
import {
  GridContainer,
  Container,
  SegmentGroup,
  FlexTableChild,
  TableContainer,
  FakeInput,
} from 'shared/StyledComponents'
import LKGrid from 'shared/LKGrid'
import dateComparer from 'loankeeper-common/helpers/dateComparer'
import { colors } from 'shared'
import { date as dateFormatter } from 'loankeeper-common/helpers/formatters'
import { translate } from 'loankeeper-common/helpers'
import { LKHeader } from 'loankeeper-common/components'
import { uccOperChangeStatus, uccOperSend } from 'src/store/ucc'

const trans = (key) => translate(`frm_acc_entry_add-${key}`)
const transLKM = (name) => translate(`LKMESSAGE-${name}`)

const config = {
  gridIdentity: {
    formName: 'frm_acc_entry_add',
    objectName: 'dbgrd_payments',
  },

  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,
  enableColumnsHide: true,
  syncGridState: false,

  getRowStyle: ({ node: { data } }) => {
    if ([0, 1].indexOf(data.ValidTran) === 1) {
      return { color: colors.black }
    }
    if ([0, 1].indexOf(data.ValidTran) === 0) {
      return { color: colors.grey }
    }
  },

  columnConfigs: {
    RDate: {
      comparator: dateComparer,
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    OpenDay: {
      comparator: dateComparer,
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    PaymentTime: {
      comparator: dateComparer,
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    BusinessDayID: {
      comparator: dateComparer,
      valueFormatter: ({ value }) => dateFormatter(value),
    },

    Amount: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },
    UCCSent: {
      iconComponent: (value) => (value === 0 ? 'bullet_red' : 'bullet_green'),
    },
  },
}

@connect(undefined, {
  uccChangeStatus: (params) => uccOperChangeStatus(params),
  uccSend: (params) => uccOperSend(params),
  openError: (e) => LKModalActions.openError(e.Error.Message || e.Error.Text || transLKM('HINT_ERR_TITLE')),
})
class UccTabView extends React.Component {
  state = { loading: false }

  componentDidMount() {
    this.updateSums(this.props.uccViewData)
  }

  fetchUccView = () => {
    this.props.fetchUccView().then(this.updateSums)
  }

  updateSums = (data) => {
    const amount = data.reduce((sum, { Amount }) => sum + parseFloat(Amount, 0), 0)

    const commission = data.reduce((sum, { AgentCommission }) => sum + parseFloat(AgentCommission, 0), 0)

    this.setState({ loading: false, amount, commission, total: amount + commission })
  }

  changeStatus = ({ ID, HashSum_PayRequestID_, ValidTran }) => {
    this.setState({ loading: true })

    new Promise(async (resolve, reject) => {
      const uccResult = await this.props.uccChangeStatus({
        PayRequestID: ID,
        HashSum_PayRequestID_,
        StatusID: ValidTran === 1 ? 0 : 1,
      })

      if (uccOperChangeStatus.fulfilled.match(uccResult)) {
        resolve()
      } else {
        reject(uccResult.payload)
      }
    })
      .then(this.props.fetchUccView)
      .catch((e) => this.props.openError(e))
      .finally(() => this.setState({ loading: false }))
  }

  send = ({ ID, HashSum_PayRequestID_ }) => {
    this.setState({ loading: true })

    new Promise(async (resolve, reject) => {
      const uccResult = await this.props.uccSend({
        PayRequestID: ID,
        HashSum_PayRequestID_,
        OID: this.props.mainTabData.OID,
        HashSum_OID_: this.props.mainTabData.HashSum_OID_,
      })

      if (uccOperSend.fulfilled.match(uccResult)) {
        resolve()
      } else {
        reject(uccResult.payload)
      }
    })
      .then(this.props.fetchUccView)
      .catch((e) => this.props.openError(e))
      .finally(() => this.setState({ loading: false }))
  }

  getContextMenuItems = ({ node: { data } }) => [
    {
      name: trans('Retry'),
      action: () => this.send(data),
      icon: 'reverse',
      disabled: data.Auth === 0,
    },

    {
      name: trans('Disable/Enable Payment'),
      action: () => this.changeStatus(data),
      icon: 'disableenable_payment',
    },
  ]

  render() {
    return (
      <Tab.Pane style={{ padding: 0 }}>
        <Container>
          <SegmentGroup>
            <Segment.Group name="top" vertical className="u-flex u-fluid" style={{ margin: '5px' }}>
              <Segment
                className="u-flex u-fluid u-directionRow"
                style={{ padding: 0, marginBottom: 10, paddingTop: 5, height: 350 }}
              >
                <FlexTableChild>
                  <TableContainer>
                    <LKGrid
                      instanceName="ORDER_UCC"
                      rowData={this.props.uccViewData}
                      onRowSelected={this.onRowSelected}
                      getContextMenuItems={this.getContextMenuItems}
                      loading={this.state.loading}
                      {...config}
                    />
                  </TableContainer>
                </FlexTableChild>
              </Segment>

              <Segment>
                <GridContainer>
                  <Grid Columns={6}>
                    <Grid.Row>
                      <Grid.Column textAlign="left" width={3} />
                      <Grid.Column textAlign="right" width={1} verticalAlign="middle">
                        {trans('lbl_total')}
                      </Grid.Column>

                      <Grid.Column textAlign="right" width={2}>
                        <FakeInput fullHeight>
                          <Segment>
                            <LKHeader size="small">{this.state.amount}</LKHeader>
                          </Segment>
                        </FakeInput>
                      </Grid.Column>
                      <Grid.Column className="u-flex u-directionRow u-alignCenter" width={2} textAlign="right">
                        <FakeInput fullHeight>
                          <Segment>
                            <LKHeader size="small">{this.state.commission}</LKHeader>
                          </Segment>
                        </FakeInput>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={2}>
                        <FakeInput fullHeight>
                          <Segment>
                            <LKHeader size="small">{this.state.total}</LKHeader>
                          </Segment>
                        </FakeInput>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={6} />
                    </Grid.Row>
                  </Grid>
                </GridContainer>
              </Segment>
            </Segment.Group>
          </SegmentGroup>
        </Container>
      </Tab.Pane>
    )
  }
}

export default UccTabView
